import React from 'react';
import { ReactComponent as WarningIcon } from 'images/warning.svg';
import { NoDataWrapper } from './styles/NoBoxScoreDataStyles';

const NoBoxScoreData = () => {
  return (
    <NoDataWrapper>
      <WarningIcon />
      <div>No secondary source is available for this game</div>
    </NoDataWrapper>
  );
};

export default NoBoxScoreData;
